import { render, staticRenderFns } from "./Release.vue?vue&type=template&id=7d99e479&scoped=true"
import script from "./Release.vue?vue&type=script&lang=js"
export * from "./Release.vue?vue&type=script&lang=js"
import style0 from "./Release.vue?vue&type=style&index=0&id=7d99e479&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d99e479",
  null
  
)

export default component.exports